import { useStorage } from '../../composables/Storage.js'
import { useStorageCookie, $cookies } from '../../composables/StorageCookie.js'
import { ref } from 'vue'

const [fullList] = useStorage('cookieManager.fullList', [], 'local')
const [currentCookiesState] = useStorageCookie('cookieManager.state', 'N/A')
const [currentCookies] = useStorageCookie('cookieManager.selectedCookies', [])


export function getCurrentCookiesState() {
  return currentCookiesState.value
}

export function getCurrentCookies() {
  return currentCookies.value
}

export function getFullList() {
  return fullList.value
}

export function clearUnwantedCookies() {
  const domainList = getDomains()
  const cookieList = getFullList()
  const cookieTypes = getCurrentCookies()

  // console.log({
  //   domainList,
  //   cookieList,
  //   cookieTypes
  // })

  // nic neni v seznamu, nic nevybral, nic neodmitl, neni co maazt
  if (!cookieTypes.length) {
    return
  }

  try {
    // iterace nad domenama
    for (var d = 0; d < domainList.length; d++) {
      // typy cookies
      for (const [type, o] of Object.entries(cookieList)) {
        // mazeme jen kdyz vsechno vypnul nebo to co nema povolene v seznamu
        if (type === 'DENY_ALL' || !cookieTypes.includes(type)) {
          // jednotlive cookies pod konkretnim typem
          Object.values(o).forEach(c => {
            $cookies.remove(c.name)
            $cookies.remove(c.name, c.path, domainList[d])
            $cookies.remove(c.name, null, domainList[d])
          })
        }
      }
    }
  } catch (error) {
    console.log(error)
  }
}

export let savedCallback = ref(null)

export function cookieManagerInit (callback = null) {
  console.log($cookies)
  savedCallback.value = callback
}

// helpers
function getDomains() {
  var domain = document.domain
  var domainSplit = domain.split('.')
  var lastFrags = [domainSplit.pop(), domainSplit.pop()].reverse()
  var domainList = [domain, '.' + domain, lastFrags.join('.')]

  return domainList
}
